var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.25H7.05588C7.41774 3.84437 9.49348 2 12 2C14.5065 2 16.5823 3.84437 16.9441 6.25H14C13.5858 6.25 13.25 6.58579 13.25 7C13.25 7.41421 13.5858 7.75 14 7.75H17V10.25H14C13.5858 10.25 13.25 10.5858 13.25 11C13.25 11.4142 13.5858 11.75 14 11.75H16.9441C16.5823 14.1556 14.5065 16 12 16C9.49348 16 7.41774 14.1556 7.05588 11.75H9C9.41421 11.75 9.75 11.4142 9.75 11C9.75 10.5858 9.41421 10.25 9 10.25H7V7.75H9C9.41421 7.75 9.75 7.41421 9.75 7C9.75 6.58579 9.41421 6.25 9 6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.25C5.41421 9.25 5.75 9.58579 5.75 10V11C5.75 14.4518 8.54822 17.25 12 17.25C15.4518 17.25 18.25 14.4518 18.25 11V10C18.25 9.58579 18.5858 9.25 19 9.25C19.4142 9.25 19.75 9.58579 19.75 10V11C19.75 15.0272 16.6783 18.337 12.75 18.7142V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V18.7142C7.3217 18.337 4.25 15.0272 4.25 11V10C4.25 9.58579 4.58579 9.25 5 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneAlt1);
export default __webpack_public_path__ + "static/media/microphone-alt-1.1ccb19b2b7e7fdc914a67e2477ef1e2e.svg";
export { ForwardRef as ReactComponent };